/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_TailwindInputs */

const en_ui_weather_tailwind = /** @type {(inputs: Ui_Weather_TailwindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tailwind`)
};

const de_ui_weather_tailwind = /** @type {(inputs: Ui_Weather_TailwindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rückenwind`)
};

/**
* | output |
* | --- |
* | "Tailwind" |
*
* @param {Ui_Weather_TailwindInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_tailwind = /** @type {((inputs?: Ui_Weather_TailwindInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_TailwindInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_tailwind(inputs)
	return de_ui_weather_tailwind(inputs)
});